import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import './style';

const Tooltip = (props) => {
  const {
    children,
    content,
    ...attr
  } = props;

  return (
    <Tippy
      content={content}
      {...attr}
    >
      {children}
    </Tippy>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node,
  content: PropTypes.node,
};

Tooltip.defaultProps = {
  children: null,
  content: '',
};

export default Tooltip;
